import axios from 'axios';

// Get individual area's info
export const getPiluMobileStats = async (date1, date2, division) => {
	return await axios({
		method: 'post',
		url: 'https://desarrollo-web-323816.uc.r.appspot.com/api/pilu/events-stats',
		data: {
			date1,
			date2,
			division,
		},
	});
};
